import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormLink from '../../../../../library/form/components/FormLink';
import FormWrapper from "../../../../../library/form/components/FormWrapper";

const ProdIOOExoSumViewRow = (props) => {
    const { formObject, index, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn30">
                    <span>{index}</span>
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormLink formObject={formObject} rowKey={rowKey} kscFormula=""
                        action={{ 
                            paramName: "actualItem", 
                            actionId: "show", actionName: "itemComp",
                            containerKey: "custom",
                            actionParam:{showModeID: "qv"} 
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "units" }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation1Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation1" }} />
                </FormWrapper>
                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn70" headerKey="viewConfig" 
                    action={{ paramName: "variation2Name" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "variation2" }} />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyRequired" }} />
                </li>
                {/* <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturned" }} />
                </li> */}
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyAvailable" }} />
                </li>
                <FormWrapper formObject={formObject} headerKey="viewConfig" action={{ paramName: "enableQC" }} >
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyQCed" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyPassed" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn90">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyFailed" }} />
                   </li>
                </FormWrapper>
                <li className="uiColumnCenter uiColumn90">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qtySendBack" }} />
                </li>
                <li className="uiColumnCenter uiColumn50 uiSpacer5">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "status" }} />
                </li>
            </ul>
        )
}

export default ProdIOOExoSumViewRow